<div class="uk-card-default" class="card-width">
  <button
    *ngIf="dataDoc && dataDoc.length && selectedItems && selectedItems.length"
    kendoButton
    [primary]="true"
    class="size-download"
    (click)="downloadDoc()"
    [svgIcon]="svgDownload"
  ></button>
  <kendo-tabstrip (tabSelect)="onTabSelect($event)" [ngStyle]="{ 'margin-top': '1.2%' }" class="loader-height">
    <kendo-tabstrip-tab
      *ngFor="let menu of this.listMenu; let i = index"
      [selected]="i == selected"
      [title]="menu.name"
      [disabled]="menu.disabled"
    >
      <ng-template kendoTabContent>
        <kendo-treeview
          [nodes]="dataDoc"
          [children]="children"
          [hasChildren]="hasChildren"
          textField="text"
          childrenField="items"
          kendoTreeViewExpandable
          kendoTreeViewHierarchyBinding
        >
          <ng-template kendoTreeViewNodeTemplate let-dataItem>
            <input type="checkbox" [checked]="dataItem._selected" (change)="onCheckItem(dataItem)" />
            {{ dataItem.libelle_doc }}
          </ng-template>
        </kendo-treeview>

        <lib-ags-loading *ngIf="isLoadingVrac || isLoadingDoc"></lib-ags-loading>

        <p *ngIf="!isLoadingVrac && !isLoadingDoc && !(dataDoc && dataDoc.length)" class="doc-message">
          Aucun document trouvé
        </p>
        <div class="upload-component" *ngIf="!isLoadingVrac && !isLoadingDoc">
          <div class="uk-card-default card1">
            <ags-document-management [listInfoDoc]="dataDocVrac" (updateList)="getDocumentVracInformation(idSession)">
            </ags-document-management>
          </div>
          <div class="card-content card2">
            <lib-ags-upload-file (amzoneInfo)="uploadInfo($event)"></lib-ags-upload-file>
          </div>
        </div>
        <div
          *ngIf="errorServer"
          [@alertDisplay]=""
          class="invalid-feedback-value k-text-center font-size-100 k-text-center"
          role="alert"
        >
          <strong>Impossible</strong> d'ajouter le fichier, veuillez réessayer plus tard.
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
